import {
  EntitiesDocument,
  EntitiesQuery,
  EntityFragment,
  StandardListHookOptions,
  useEntitiesQuery,
  useOnEntityCreatedSubscription,
  useOnEntityUpdatedSubscription,
  withStandardListHook,
} from '@spotify/confidence-graphql';

const useEntitiesImpl = withStandardListHook<
  EntitiesQuery,
  EntityFragment,
  'entities'
>(useEntitiesQuery, 'entities');

export const useEntities = (options: StandardListHookOptions = {}) => {
  useOnEntityCreatedSubscription({
    onData: ({ client }) => {
      client.refetchQueries({
        include: [EntitiesDocument],
      });
    },
  });

  useOnEntityUpdatedSubscription();

  return useEntitiesImpl(options);
};
